'use client';

import '@/lib/polyfills';
import { ReactNode } from 'react';

/**
 * Client-side polyfills provider component.
 * This ensures polyfills are only loaded and executed in the browser.
 * Wraps children to maintain provider pattern consistency.
 */
export default function PolyfillsProvider({ children }: { children: ReactNode }) {
  return <>{children}</>;
}
